const CONTACT_INFO = {
  companyName: 'Medical Store Admin Panel',
  address: 'G-27, 2nd Floor, Sector 4, Kolkata - 700091, West Bengal, India',
  phone: '+91 8620 8283 85',
  email: 'support@medicin.com',
  social: {
    facebook: '#',
    twitter: '#',
    instagram: '#',
    linkedin: '#'
  }
};

export default CONTACT_INFO;
